function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m384.011719 256c0 88.367188-71.632813 160-160 160-88.363281 0-160-71.632812-160-160s71.636719-160 160-160c88.367187 0 160 71.632812 160 160zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m202.679688 21.332031v36.503907c0 11.796874 9.554687 21.332031 21.332031 21.332031 11.777343 0 21.332031-9.535157 21.332031-21.332031v-36.503907c0-11.796875-9.554688-21.332031-21.332031-21.332031-11.777344 0-21.332031 9.535156-21.332031 21.332031zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m30.96875 122.21875c-10.519531-5.289062-23.339844-1.089844-28.675781 9.429688-5.308594 10.515624-1.085938 23.359374 9.429687 28.671874l30.933594 15.636719c3.09375 1.558594 6.378906 2.28125 9.601562 2.28125 7.785157 0 15.296876-4.265625 19.070313-11.710937 5.3125-10.515625 1.109375-23.359375-9.40625-28.671875zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m42.65625 336.042969-30.933594 15.636719c-10.515625 5.3125-14.71875 18.15625-9.40625 28.671874 3.753906 7.445313 11.265625 11.710938 19.070313 11.710938 3.222656 0 6.53125-.722656 9.601562-2.28125l30.933594-15.636719c10.515625-5.3125 14.71875-18.15625 9.40625-28.671875-5.332031-10.539062-18.175781-14.761718-28.671875-9.429687zm0 0"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m224.011719 432.832031c-11.777344 0-21.332031 9.535157-21.332031 21.332031v36.503907c0 11.796875 9.554687 21.332031 21.332031 21.332031 11.777343 0 21.332031-9.535156 21.332031-21.332031v-36.503907c0-11.796874-9.554688-21.332031-21.332031-21.332031zm0 0"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m436.300781 351.679688-30.933593-15.636719c-10.496094-5.3125-23.339844-1.089844-28.671876 9.40625-5.3125 10.519531-1.109374 23.363281 9.40625 28.671875l30.933594 15.640625c3.09375 1.554687 6.378906 2.28125 9.601563 2.28125 7.785156 0 15.296875-4.265625 19.070312-11.710938 5.335938-10.496093 1.109375-23.339843-9.40625-28.652343zm0 0"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m417.058594 122.21875-30.933594 15.636719c-10.519531 5.3125-14.722656 18.15625-9.410156 28.671875 3.757812 7.445312 11.265625 11.710937 19.074218 11.710937 3.21875 0 6.527344-.722656 9.597657-2.28125l30.933593-15.636719c10.519532-5.3125 14.722657-18.15625 9.410157-28.671874-5.335938-10.519532-18.175781-14.761719-28.671875-9.429688zm0 0"
});

var SvgMode = function SvgMode(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "512pt",
    viewBox: "-32 0 512 512",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMode, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mode.d0e7a205.svg";
export { ForwardRef as ReactComponent };